module.exports = __webpack_public_path__ + "media/images/logo_transparent-8a2c531ca526649cd566c6a6f4776004.png";